import React, { useContext } from "react";
import { Button, Container, Line } from "../../Styles/Global.Styled";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import ProfileIcon from "../../Icons/ProfileIcon";
import { css } from "styled-components";
import Login from "../../Pages/Login";

const topbarContainer = css`
  justify-content: flex-end;
  width: 100%;
  padding: 0.25vh 10vw;
  background-color: ${({ theme }) => theme.bgColor};
  gap: 0.25vh;
`;
const hideStyle = css`
  display: none;
`;
const lineStyle = css`
  height: auto;
  width: 0;
  border-width: 1px;
  border-color: grey;
`;
const bttnIconStyle = css`
  gap: 0.5vh;
`;

const TopBar = ({ setPopUp }) => {
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useContext(AuthContext);
  return (
    <Container $baseStyle={topbarContainer} $mStyle={hideStyle}>
      {isLoggedIn ? (
        <Container>
          <Button onClick={() => logout()}>Log out</Button>
          <Line $baseStyle={lineStyle} />
          <Button
            $baseStyle={bttnIconStyle}
            onClick={() => navigate("/my-account")}
          >
            My Account
            <ProfileIcon />
          </Button>
        </Container>
      ) : (
        <Container>
          <Button onClick={() => navigate("/register")}>
            Become a partner
          </Button>
          <Line $baseStyle={lineStyle} />
          <Button
            onClick={() =>
              setPopUp({
                isOpen: true,
                content: <Login setPopUp={setPopUp} />,
              })
            }
          >
            Login
          </Button>
        </Container>
      )}
    </Container>
  );
};

export default TopBar;
